import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getCommissionCycleDates(locationId, commissionCycleId) {
	const query = gql`
		query getCommissionCycle($locationId: String!, $id: String!) {
			getCommissionCycle(locationId: $locationId, id: $id) {
				_id
				startDate
				endDate
				status
			}
		}
	`;

	const variables = {
		locationId,
		id: commissionCycleId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCommissionCycle;
	} catch (err) {
		errorLogger(err, { function: "getCommissionCycleDates", message: "Error getting commission cycle dates", variables });
		return null;
	}
}

export async function getUsersSelect(locationId, position) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				fullName
				employeeId
				position
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			position,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data?.data?.getUsers;
	} catch (err) {
		errorLogger(err, { function: "getUsersSelect", message: "Error getting users select", variables });
		return null;
	}
}
